import styled from "styled-components";

export const PropGraphDocsLayout = styled.div`
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  background: #ffffff;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(0, 1fr);
  }
`;

export const PropGraphDocsSidebar = styled.aside`
  min-height: 0;
  padding: 12px;
  border-right: 1px solid #e5e7eb;
  background: #f8fafc;
  overflow: auto;

  @media (max-width: 900px) {
    max-height: 260px;
    border-right: 0;
    border-bottom: 1px solid #e5e7eb;
  }
`;

export const PropGraphDocsContent = styled.main`
  min-height: 0;
  overflow: auto;
  padding: 20px 28px 32px;
`;

export const PropGraphDocsArticle = styled.article`
  max-width: 980px;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.75;

  h2 {
    margin: 0 0 12px;
    color: #0f172a;
    font-size: 22px;
  }

  h3 {
    margin: 22px 0 8px;
    color: #0f172a;
    font-size: 16px;
  }

  p {
    margin: 8px 0;
  }

  ul,
  ol {
    margin: 8px 0 8px 20px;
    padding: 0;
  }

  li {
    margin: 4px 0;
  }

  table {
    width: 100%;
    margin: 12px 0;
    border-collapse: collapse;
    table-layout: fixed;
  }

  th,
  td {
    border: 1px solid #e5e7eb;
    padding: 8px 10px;
    vertical-align: top;
  }

  th {
    background: #f8fafc;
    color: #0f172a;
    font-weight: 600;
  }

  code {
    padding: 1px 4px;
    border-radius: 4px;
    background: #f1f5f9;
    color: #0f172a;
  }

`;

export const PropGraphDocsText = styled.span<{ $compact?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  gap: ${({ $compact }) => ($compact ? 2 : 4)}px;
  max-width: 100%;
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  line-height: ${({ $compact }) => ($compact ? 1.45 : 1.65)};

  .propgraph-description-line {
    display: block;
  }
`;
